import { render, staticRenderFns } from "./FamilyLine.vue?vue&type=template&id=64f716ae&scoped=true&"
import script from "./FamilyLine.vue?vue&type=script&lang=js&"
export * from "./FamilyLine.vue?vue&type=script&lang=js&"
import style0 from "./FamilyLine.vue?vue&type=style&index=0&id=64f716ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f716ae",
  null
  
)

export default component.exports